// eslint-disable-next-line import/no-unresolved
import { Swiper, SwiperSlide } from 'swiper/react';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css/bundle';
import { Navigation } from 'swiper';
import { useEffect, useState } from 'react';
import Image from 'next/image';
import Link from 'components/helper/link';
import imageUri from 'components/helper/image';
import date from 'lib/filters/date';
import { fetchAPI } from 'lib/connect';
import UserIcon from '../../../public/assets/icons/anker/user.svg';
import CabinIcon from '../../../public/assets/icons/anker/bed.svg';
import LengthIcon from '../../../public/assets/icons/anker/length.svg';
import CalendarIcon from '../../../public/assets/icons/anker/calendar.svg';
import DestinationIcon from '../../../public/assets/icons/anker/port.svg';

export default function CruiseSlider({ searchQueryParams }) {
  const [boats, setBoats] = useState([]);

  useEffect(() => {
    const params = searchQueryParams;
    if (searchQueryParams?.limit === undefined) {
      params.limit = 10;
    }
    fetchAPI('/search', params)
      .then((data) => {
        setBoats(data.data);
      });
  }, [searchQueryParams]);

  return (
    <div>
      {
        boats.length > 0
        && (
          <Swiper
            slidesPerView={3}
            spaceBetween={10}
            loop
            breakpoints={{
              '@0.1': {
                slidesPerView: 1,
              },
              '@0.75': {
                slidesPerView: 2,
              },
              '@1.00': {
                slidesPerView: 3,
              },
            }}
            modules={[Navigation]}
            navigation
            className="w-full"
          >
            {boats.map((offer, k) => (
              <SwiperSlide key={k}>
                <Link href={{
                  pathname: `/yacht/${offer.boat.slug}`,
                  query: {
                    bq: offer.booking_query,
                    date_from: offer.date_from,
                    date_to: offer.date_to,
                    duration: offer.duration,
                  },
                }}
                >
                  <a className="text-primary cursor-pointer">
                    <h5 className="p-1 pb-0 font-bold bg-action text-center">{offer.boat.title}</h5>
                    <Image
                      src={imageUri(offer.boat.photo_url, { w: 1000 })}
                      layout="responsive"
                      width="400"
                      height="250"
                      objectFit="cover"
                      alt={offer.boat.title}
                      title={offer.boat.title}
                    />
                    {offer.license === 0 && (
                      <div
                        className="-mt-7 w-3/5 relative bg-primary bg-opacity-75 text-white text-sm p-1 text-center"
                      >
                        auch
                        ohne Führerschein
                      </div>
                    )}
                    <div className="relative p-2 bg-gray-200 text-sm">
                      <div className="flex items-center basis-full font-semibold">
                        <CalendarIcon className="mr-2" width={14} />
                        {date(offer.date_from)}
                        {' '}
                        -
                        {' '}
                        {date(offer.date_to)}
                        <span
                          className="text-xs ml-2 leading-4 font-semibold bg-gray-100 rounded-xl text-primary-500 text-center py-0.5 px-2.5"
                        >
                          {offer.duration}
                          {' '}
                          Nächte
                        </span>
                      </div>
                      <div className="flex mb-2">
                        <DestinationIcon className="mr-2 ml-0.5 fill-primary" width={12} />
                        <span className="line-clamp-1">{offer.basement_start.location.half}</span>
                      </div>
                      <div className="flex">
                        <div className=" basis-1/3 ">
                          <div className="flex items-center">
                            <UserIcon height={14} className="mr-2 fill-primary" />
                            <span className="font-semibold">Kojen</span>
                          </div>
                          <div className="ml-6">
                            {offer.boat.berth.fixed}
                            (+
                            {offer.boat.berth.variable}
                            )
                          </div>
                        </div>
                        <div className="basis-1/3">
                          <div className="flex items-center">
                            <CabinIcon height={14} className="mx-2 fill-primary" />
                            <span className="font-semibold">Kabinen</span>
                          </div>
                          <div className="ml-7">
                            {offer.boat.cabins}
                          </div>
                        </div>
                        <div className="basis-1/3">
                          <div className="flex items-center">
                            <LengthIcon height={14} className="mx-2 fill-primary" />
                            <span className="font-semibold">Länge</span>
                          </div>
                          <div className="ml-7">
                            {offer.boat.length}
                            &nbsp;m
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="w-full">
                      <div className="text-right font-bold pr-2 w-1/2 bg-primary text-white relative left-1/2">
                        schon ab
                        {' '}
                        <strong>
                          {offer.price}
                          &nbsp;&euro;
                        </strong>
                      </div>
                    </div>
                  </a>
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
        )
      }
    </div>
  );
}
